/* Original Renegade v39 — progressive FAQ accordion enhancement. */
(function(){'use strict';
function boot(){
  var body=document.querySelector('.page-body--utility');
  if(!body||body.dataset.orFaqEnhanced==='1')return;
  var headings=Array.prototype.slice.call(body.children).filter(function(node){return node.tagName==='H3';});
  if(!headings.length)return;
  var entries=headings.map(function(heading){
    var cursor=heading.previousElementSibling,group=null;
    while(cursor){if(cursor.tagName==='H2'){group=cursor;break;}cursor=cursor.previousElementSibling;}
    return{heading:heading,group:group};
  });
  body.dataset.orFaqEnhanced='1';
  var currentList=null,lastGroup=null;
  entries.forEach(function(entry){
    var heading=entry.heading;
    if(!heading.parentNode)return;
    if(!currentList||entry.group!==lastGroup){
      currentList=document.createElement('div');
      currentList.className='or-faq-list';
      heading.parentNode.insertBefore(currentList,heading);
      lastGroup=entry.group;
    }
    var details=document.createElement('details');
    details.className='or-faq-item';
    var summary=document.createElement('summary');
    summary.className='or-faq-item__summary';
    summary.textContent=heading.textContent.trim();
    var answer=document.createElement('div');
    answer.className='or-faq-item__body or-faq-answer';
    var cursor=heading.nextSibling;
    while(cursor){
      var next=cursor.nextSibling;
      if(cursor.nodeType===1&&(cursor.tagName==='H3'||cursor.tagName==='H2'))break;
      answer.appendChild(cursor);
      cursor=next;
    }
    currentList.appendChild(details);
    details.appendChild(summary);
    details.appendChild(answer);
    heading.remove();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
